module.exports = __webpack_public_path__ + "img/multi-site-screen.ea91bb35.svg";